import { keyframes } from '@emotion/react';

/* Animation */
export const fadeIn = keyframes`
    0% {
        opacity: 0;
        visibility: hidden;
    }
    100% {
        opacity: 1;
        visibility: visible;
    }
`;

export const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

/* Transition */
export const easeOpacity = 'opacity 0.2s ease';
export const easeTransform = 'transform 0.2s ease';
